'use strict';

export default class LangSwitcher {
    constructor() {
    }
}
